'use strict';

angular.module('shiftTraderApp')
  .factory('Projections', function (ServerUrls, Session, $http, $q) {
    var endpointName = 'projections/';

    var Projection = function(values) {
      var A = {};

      A.$reinitialize = function(data) {
        angular.extend(A, data);

        A.created_at = moment.utc(A.created_at).tz(Session.getTimezone());

        _.each(['gross_revenue', 'cost', 'week_labor_percentage_goal', 'labor_hours'], function(prop) {
          if (!_.isNull(A[prop])) {
            A[prop] = parseFloat(A[prop]);
          }
        });
      };

      A.$reinitialize(values);

      return A;
    };

    var Projections = {};

    Projections.create = function (data) {
      return $http.post(ServerUrls.current.railsApi + endpointName, data)
        .then(function (response) {
          return new Projection(response.data);
        }, function(response) {
          return $q.reject(response);
        });
    };

    Projections.getById = function(setId) {
      return $http.get(ServerUrls.current.railsApi + endpointName + '/' + setId)
        .then(function(response) {
          return new Projection(response.data);
        }, function(response) {
          return $q.reject(response);
        });
    };

    Projections.getAll = function(params) {
      var config = {
        params: _.extend({}, params)
      };

      return $http.get(ServerUrls.current.railsApi + endpointName, config)
        .then(function(response) {
          return _.map(response.data, function(ar) {
            return new Projection(ar);
          });
        }, function(response) {
          return $q.reject(response);
        });

    };

    Projections.initWithData = function(data) {
      return new Projection(data);
    };

    return Projections;
  });
